export enum CustomerFollowUpEnum {
    CUSTOMER_NOT_RESPONDING ="Customer not responding",
    CUSTOMER_ASKED_TO_CALL_BACK_LATER = "Customer asked to call back later",
    CUSTOMER_HAS_NEW_ISSUE = "Customer has new issues",
    CUSTOMER_RESPONDS_THAT_THEY_WILL_PAY_LATER = "Customer responds that they will pay later",
    CUSTOMER_NEEDS_DISCOUNT = "Customer needs discount",
    CUSTOMER_REQUESTED_TO_CLOSE_BUNDLE = "Customer requested to close bundle",
    OTHER = "Other"
}